import { Tag, Typography } from 'antd'
import dayjs from 'dayjs'
import { ITableOrder } from 'models/orders'
import { orderHistoryEventTags, orderTags } from 'shared/constants/orders'
import { getOrderStatusHistory } from 'shared/utils/orders/getOrderStatusHistory'
import styles from './OrderStatusHistory.module.scss'

interface IOrderStatusHistoryProps {
  order: ITableOrder
}

export const OrderStatusHistory: React.FC<IOrderStatusHistoryProps> = ({ order }) => {
  const history = getOrderStatusHistory(order)

  if (!history.length) {
    return (
      <Typography.Text className={styles.empty}>
        Статус заказа ещё не менялся
      </Typography.Text>
    )
  }

  return (
    <div className={styles.wrapper}>
      {history.map((item) => {
        const tag = item.event
          ? orderHistoryEventTags[item.event]
          : item.status
            ? orderTags[item.status]
            : undefined

        return (
          <div className={styles.item} key={`${item.event ?? item.status}-${item.changed_at}`}>
            <div className={styles.event}>
              <Tag color={tag?.color} className={styles.status}>
                {tag?.label ?? item.event ?? item.status}
              </Tag>
              {item.comment && (
                <Typography.Text type='secondary'>{item.comment}</Typography.Text>
              )}
            </div>
            <Typography.Text className={styles.date}>
              {dayjs(item.changed_at).format('DD.MM.YYYY HH:mm')}
            </Typography.Text>
          </div>
        )
      })}
    </div>
  )
}
